import * as React from 'react'
import {
  dispatchToProps,
  IBillingPaymentsListContainerProps,
} from './BillingPaymentsList.container'
import { Table, TableHeader, TableRow } from 'features/Table'
import Pagination from 'components/Pagination'
import EmptyMessageCard from 'components/Cards/EmptyMessageCard'
import { useGetBillingPaymentsQuery } from 'src/generated/graphql'
import LoadingOverlay from 'components/Loading/LoadingOverlay'
import * as sLay from 'styles/modules/layout.scss'
import cn from 'classnames'
import SelectPretty from 'components/Input/SelectPretty'
import * as sMarg from 'styles/modules/margins.scss'
import { Field } from 'redux-form'
import { Row, Col } from 'components/Layout'

export interface IBillingPaymentsListComponentProps extends IBillingPaymentsListContainerProps {
  replace: typeof dispatchToProps.replace
  banOptions: any
}

export const BillingPaymentsListComponent = (props: IBillingPaymentsListComponentProps) => {
  const { page, replace, banOptions, ban } = props

  const selectBan = () => {
    replace({
      pathname: '/dashboard/billing/payments',
      query: { ban, page: 1 },
    })
  }

  const { data, loading } = useGetBillingPaymentsQuery({ variables: { page, ban } })

  if (loading || !data || !data?.billingPayments) return <LoadingOverlay transparent />
  const { results, totalPages } = data.billingPayments
  return (
    <div>
      <Row
        className={cn(
          sMarg.mb30,
          sLay['layout-gt-xs-column'],
          sLay['layout-gt-xs-row'],
          sLay['layout-align-end'],
          'sm'
        )}
      >
        <Col className={cn('sm', sMarg.mb15xs)}>
          <Field
            label="Billing Account"
            component={SelectPretty}
            name="ban"
            options={banOptions}
            display="box"
            onChangeAlt={selectBan}
          />
        </Col>
      </Row>
      {results.length === 0 ? (
        <EmptyMessageCard
          title="You have no payments"
          subtitle="They'll appear here once you have paid a bill."
        />
      ) : (
        <div>
          <Table
            header={
              <TableHeader>
                <div>Date</div>
                <div>Bill Number</div>
                <div className={sLay['hide-xs']}>Reference</div>
                <div>Amount</div>
              </TableHeader>
            }
          >
            {results.map(payment => {
              return (
                <TableRow key={payment.id}>
                  <div>{payment.date}</div>
                  <div>{payment.billNumber}</div>
                  <div className={sLay['hide-xs']}>{payment.reference}</div>
                  <div>${payment.amount}</div>
                </TableRow>
              )
            })}
          </Table>
        </div>
      )}
      <Pagination
        page={page}
        numPages={totalPages}
        onClick={nextPage =>
          replace({
            pathname: location.pathname,
            query: {
              ban,
              page: nextPage,
            },
          })
        }
      />
    </div>
  )
}



// WEBPACK FOOTER //
// src/features/BillingPayments/BillingPaymentsList/BillingPaymentsList.tsx